import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/setting.svg';
const SetCalendarSvg = () => React.createElement(IconSvg, null);
export default SetCalendarSvg;
